// FitClutch — funil web — textos em hindi
export default {
  'ageSelect.titleLine1': 'अपना',
  'ageSelect.titleHighlight': 'व्यक्तिगत वर्कआउट प्लान बनाएं',
  'ageSelect.poweredBy': 'FitClutch AI द्वारा संचालित',
  'ageSelect.subtitle': 'शुरू करने के लिए अपनी आयु सीमा चुनें',
  'ageSelect.duration': '3 मिनट का क्विज़',
  'ageSelect.ageLabel': 'आयु: {range}',
  'ageSelect.footnote': 'जारी रखकर, आप हमारी {terms} और {privacy} से सहमत होते हैं।',
  'ageSelect.termsLink': 'उपयोग की शर्तें',
  'ageSelect.privacyLink': 'गोपनीयता नीति',

  'gender.title': 'आपका लिंग क्या है?',
  'gender.subtitle': 'हम इसका उपयोग केवल आपकी योजना को निजीकृत करने के लिए करते हैं',
  'gender.male': 'पुरुष',
  'gender.female': 'महिला',
  'gender.other': 'नहीं बताना चाहते',

  'socialProof.genderWomen': 'महिलाएं',
  'socialProof.genderMen': 'पुरुष',
  'socialProof.genderPeople': 'लोग',
  'socialProof.decade20': 'अपने 20 के दशक में',
  'socialProof.decade30': 'अपने 30 के दशक में',
  'socialProof.decade40': 'अपने 40 के दशक में',
  'socialProof.decade50': 'अपने 50 या उससे अधिक की उम्र में',
  'socialProof.headlineBig': '{users} से अधिक {gender}',
  'socialProof.subcopy': '{decade} पहले से ही FitClutch पर भरोसा करते हैं <hl>अपने लक्ष्यों, फिटनेस स्तर और उपलब्ध उपकरणों के हिसाब से</hl>। आपके आगे बढ़ने के साथ यह खुद को ढालता है।',
  'socialProof.subcopyNoDecade': 'पहले से ही FitClutch पर भरोसा करते हैं <hl>अपने लक्ष्यों, फिटनेस स्तर और उपलब्ध उपकरणों के हिसाब से</hl>। आपके आगे बढ़ने के साथ यह खुद को ढालता है।',
  'socialProof.downloadsLabel': 'डाउनलोड',
  'socialProof.cta': 'जारी रखें',

  'goal.question': 'आपका मुख्य फिटनेस लक्ष्य क्या है?',
  'goal.option_hipertrofia': 'मांसपेशियां बनाना',
  'goal.option_emagrecer': 'वजन कम करना',
  'goal.option_forca': 'ताकत बढ़ाना',
  'goal.option_condicionamento': 'समग्र फिटनेस सुधारना',
  'goal.feedbackLead': 'बढ़िया:',
  'goal.feedback_hipertrofia': 'हर रेप के लिए वीडियो-गाइडेड फॉर्म के साथ कस्टम स्ट्रेंथ सेशन।',
  'goal.feedback_emagrecer': 'एक ट्रेनिंग प्लान जो आपके मेटाबॉलिज्म को सक्रिय रखे।',
  'goal.feedback_forca': 'सुरक्षित तरीके से असली ताकत बनाने वाली प्रोग्रेशन।',
  'goal.feedback_condicionamento': 'सहनशक्ति, गतिशीलता और ऊर्जा सुधारने वाले संतुलित सेशन।',

  'bodyShape.question': 'आज आपके शरीर का सबसे अच्छा वर्णन कौन सा करता है?',
  'bodyShape.option_magro_male': 'दुबला',
  'bodyShape.option_magro_female': 'दुबली',
  'bodyShape.option_magro_neutral': 'दुबला-पतला शरीर',
  'bodyShape.option_cheio_male': 'भरा हुआ',
  'bodyShape.option_cheio_female': 'भरी हुई',
  'bodyShape.option_cheio_neutral': 'भरा-पूरा शरीर',
  'bodyShape.option_atletico_male': 'एथलेटिक',
  'bodyShape.option_atletico_female': 'एथलेटिक',
  'bodyShape.option_atletico_neutral': 'एथलेटिक शरीर',
  'bodyShape.option_definido_male': 'टोन्ड',
  'bodyShape.option_definido_female': 'टोन्ड',
  'bodyShape.option_definido_neutral': 'टोन्ड शरीर',
  'bodyShape.option_medio_male': 'औसत',
  'bodyShape.option_medio_female': 'औसत',
  'bodyShape.option_medio_neutral': 'औसत शरीर',

  'bodyGoal.question': 'आप किस तरह का शरीर पाना चाहते हैं?',
  'bodyGoal.option_definido_male': 'टोन्ड और सुडौल',
  'bodyGoal.option_definido_female': 'टोन्ड और सुडौल',
  'bodyGoal.option_definido_neutral': 'टोन्ड और सुडौल शरीर',
  'bodyGoal.option_atletico_male': 'एथलेटिक और मांसल',
  'bodyGoal.option_atletico_female': 'एथलेटिक और फिट',
  'bodyGoal.option_atletico_neutral': 'एथलेटिक और मांसल शरीर',
  'bodyGoal.option_magro_male': 'दुबला और हल्का',
  'bodyGoal.option_magro_female': 'दुबली और हल्की',
  'bodyGoal.option_magro_neutral': 'दुबला-पतला शरीर',
  'bodyGoal.option_curvilineo_male': 'मजबूत और भारी-भरकम',
  'bodyGoal.option_curvilineo_female': 'मजबूत और घुमावदार',
  'bodyGoal.option_curvilineo_neutral': 'मजबूत और सुडौल शरीर',

  'lastBest.question': 'आप आखिरी बार शारीरिक रूप से सबसे अच्छा कब महसूस करते थे?',
  'lastBest.option_agora': 'अभी अभी',
  'lastBest.option_menos_1_ano': 'एक साल से कम पहले',
  'lastBest.option_1_3_anos': '1-3 साल पहले',
  'lastBest.option_mais_3_anos': '3 साल से अधिक पहले',
  'lastBest.option_nunca': 'कभी नहीं',

  'weightTrend.question': 'आपका वजन आमतौर पर कैसे बदलता है?',
  'weightTrend.option_estavel': 'काफी स्थिर',
  'weightTrend.option_varia': 'मेरी आदतों के अनुसार ऊपर-नीचे होता है',
  'weightTrend.option_subindo': 'लगातार बढ़ रहा है',
  'weightTrend.option_caindo': 'लगातार घट रहा है',
  'weightTrend.option_nao_sei': 'पक्का नहीं पता',

  'transformPromo.headline': 'आपका लक्ष्य: {target}। हम आपको बिल्कुल सही तरीका दिखाएंगे।',
  'transformPromo.subcopyLead': 'बिना चोट के डर के ट्रेनिंग करें। FitClutch में हर एक्सरसाइज के लिए',
  'transformPromo.subcopyHighlight1': 'एक्सपर्ट वीडियो डेमो',
  'transformPromo.subcopyMid': 'हैं, जो सही फॉर्म में मदद करते हैं और',
  'transformPromo.subcopyHighlight2': 'चोट से बचाते हैं',
  'transformPromo.cta': 'जारी रखें',

  'pushUps.question': 'एक बार में आप अधिकतम कितने पुश-अप्स कर सकते हैं?',
  'pushUps.option_nenhuma': 'अभी तक कोई नहीं',
  'pushUps.option_1_5': '1 से 5',
  'pushUps.option_6_15': '6 से 15',
  'pushUps.option_16_30': '16 से 30',
  'pushUps.option_30_mais': '30 से अधिक',

  'squats.question': 'आप लगातार कितने स्क्वाट्स कर सकते हैं?',
  'squats.option_nenhuma': 'अभी तक कोई नहीं',
  'squats.option_1_10': '1 से 10',
  'squats.option_11_25': '11 से 25',
  'squats.option_26_50': '26 से 50',
  'squats.option_50_mais': '50 से अधिक',

  'flexibility.question': 'आप कितने फ्लेक्सिबल हैं?',
  'flexibility.option_nao_alcanco': 'पैर की उंगलियों तक नहीं पहुंच पाता/पाती',
  'flexibility.option_quase': 'लगभग पैर की उंगलियों तक पहुंच जाता/जाती हूं',
  'flexibility.option_facil': 'आसानी से पैर की उंगलियां छू लेता/लेती हूं',
  'flexibility.option_muito_flexivel': 'बहुत फ्लेक्सिबल (स्प्लिट, डीप स्ट्रेच)',
  'flexibility.option_nao_sei': 'पता नहीं',

  'progressPromo.headline': 'आपका शुरुआती बिंदु सेट हो गया है। अब देखते हैं इसे आगे बढ़ते हुए।',
  'progressPromo.subcopyLead': 'हर वर्कआउट',
  'progressPromo.subcopyHighlight': 'अपने आप रिकॉर्ड होता है',
  'progressPromo.subcopyTail': '— आपको प्रेरित रखने के लिए रियल-टाइम आंकड़े।',
  'progressPromo.cta': 'जारी रखें',

  'focusArea.question': 'आपके लक्षित क्षेत्र कौन से हैं?',
  'focusArea.subtitle': 'एक खास क्षेत्र चुनें या "पूरा शरीर" चुनें।',
  'focusArea.option_superior': 'ऊपरी शरीर',
  'focusArea.option_core': 'कोर / पेट',
  'focusArea.option_inferior': 'निचला शरीर',
  'focusArea.option_corpo_inteiro': 'पूरा शरीर',
  'focusArea.cta': 'जारी रखें',

  'injuries.question': 'क्या किसी हिस्से को ज़्यादा ख्याल चाहिए?',
  'injuries.subtitle': 'हम उन हिस्सों को बचाने के लिए आपके व्यायाम में बदलाव करेंगे।',
  'injuries.option_ombros': 'कंधे',
  'injuries.option_joelhos': 'घुटने',
  'injuries.option_costas': 'पीठ',
  'injuries.option_nenhuma': 'कोई नहीं',
  'injuries.disclaimer': 'ये बदलाव एहतियाती हैं — डॉक्टरी सलाह का विकल्प नहीं हैं।',
  'injuries.cta': 'जारी रखें',

  'workoutDuration.question': 'आपके लिए आदर्श वर्कआउट अवधि क्या है?',
  'workoutDuration.option_rapido': 'तेज़',
  'workoutDuration.option_rapido_subtitle': '3 एक्सरसाइज',
  'workoutDuration.option_rapido_badge': '20 मिनट तक',
  'workoutDuration.option_curto': 'छोटा',
  'workoutDuration.option_curto_subtitle': '4-6 एक्सरसाइज',
  'workoutDuration.option_curto_badge': '20-40 मिनट',
  'workoutDuration.option_medio': 'मध्यम',
  'workoutDuration.option_medio_subtitle': '5-7 एक्सरसाइज',
  'workoutDuration.option_medio_badge': '40-60 मिनट',
  'workoutDuration.option_longo': 'लंबा',
  'workoutDuration.option_longo_subtitle': '8-10 एक्सरसाइज',
  'workoutDuration.option_longo_badge': '60+ मिनट',

  'trainingSummaryPromo.headline': '{days}, {duration} के सेशन — बस तैयार हो रहे हैं।',
  'trainingSummaryPromo.subcopyLead': 'सीधे हमारी',
  'trainingSummaryPromo.subcopyHighlight': 'वर्कआउट लाइब्रेरी',
  'trainingSummaryPromo.subcopyTail': ' से — आपके लिए हमेशा एक तैयार रहेगा।',
  'trainingSummaryPromo.cta': 'जारी रखें',
  'trainingSummaryPromo.days_2': 'हफ्ते में 1-2 बार',
  'trainingSummaryPromo.days_4': 'हफ्ते में 3-4 बार',
  'trainingSummaryPromo.days_6': 'हफ्ते में 5-6 बार',
  'trainingSummaryPromo.days_7': 'हर दिन',

  'workSchedule.question': 'आपकी काम की दिनचर्या कैसी है?',
  'workSchedule.option_fixo': 'दफ्तर का समय',
  'workSchedule.option_noturno': 'नाइट शिफ्ट',
  'workSchedule.option_flexivel': 'लचीला समय',
  'workSchedule.option_parado': 'मैं काम नहीं कर रहा/रही',

  'dailyActivity.question': 'आपका रोज़मर्रा का दिन कितना सक्रिय होता है?',
  'dailyActivity.option_sentado': 'ज़्यादातर बैठकर',
  'dailyActivity.option_ativo': 'ज़्यादातर खड़े होकर या चलते-फिरते',
  'dailyActivity.option_misto': 'दोनों थोड़ा-थोड़ा',
  'dailyActivity.option_nao_sei': 'पता नहीं',

  'sleepHours.question': 'आप आमतौर पर कितनी नींद लेते हैं?',
  'sleepHours.option_menos_5': '5 घंटे से कम',
  'sleepHours.option_5_6': '5-6 घंटे',
  'sleepHours.option_7_8': '7-8 घंटे',
  'sleepHours.option_mais_8': '8 घंटे से ज़्यादा',

  'waterIntake.question': 'आप रोज़ कितने गिलास पानी पीते हैं?',
  'waterIntake.subtitle': 'अपनी आदत के सबसे करीब वाली संख्या चुनें।',
  'waterIntake.cta': 'जारी रखें',

  'profileSummary.headline': 'यह रही आपकी प्रोफ़ाइल',
  'profileSummary.imcLabel': 'BMI - {imc}',
  'profileSummary.imcAbaixo': 'कम',
  'profileSummary.imcNormal': 'सामान्य',
  'profileSummary.imcAcima': 'ज़्यादा',
  'profileSummary.imcObeso': 'मोटापा',
  'profileSummary.bodyTypeLabel': 'शरीर का प्रकार',
  'profileSummary.bodyType_ectomorfo': 'एक्टोमॉर्फ',
  'profileSummary.bodyType_mesomorfo': 'मेसोमॉर्फ',
  'profileSummary.bodyType_endomorfo': 'एंडोमॉर्फ',
  'profileSummary.lifestyleLabel': 'जीवनशैली',
  'profileSummary.lifestyle_sedentario': 'निष्क्रिय',
  'profileSummary.lifestyle_ativo': 'सक्रिय',
  'profileSummary.lifestyle_equilibrado': 'संतुलित',
  'profileSummary.conditioningLabel': 'फिटनेस स्तर',
  'profileSummary.conditioning_iniciante': 'बेसिक',
  'profileSummary.conditioning_intermediario': 'मध्यम',
  'profileSummary.conditioning_avancado': 'एडवांस्ड',
  'profileSummary.conditioning_especialista': 'एक्सपर्ट',
  'profileSummary.metabolismLabel': 'मेटाबॉलिज्म',
  'profileSummary.metabolism_lento': 'धीमा, आसानी से वज़न बढ़ता है',
  'profileSummary.metabolism_acelerado': 'तेज़, आसानी से वज़न घटता है',
  'profileSummary.metabolism_equilibrado': 'संतुलित',
  'profileSummary.metabolism_variavel': 'बदलता रहता है, आदतों पर निर्भर',
  'profileSummary.cta': 'जारी रखें',

  'barriers.question': 'पहले फिट होने से आपको किस चीज़ ने रोका?',
  'barriers.option_motivacao': 'कम मोटिवेशन',
  'barriers.option_sem_plano': 'कोई तय योजना नहीं',
  'barriers.option_tempo': 'समय की कमी',
  'barriers.option_lesoes': 'शारीरिक चोटें',
  'barriers.option_outro': 'अन्य कारण',

  'consistencyChart.headline': 'FitClutch आपको लगातार बने रहने में मदद करता है!',
  'consistencyChart.subcopyLead': 'आपकी पर्सनलाइज़्ड प्लान में वो सब कुछ है जो चाहिए ताकि आप',
  'consistencyChart.subcopyHighlight1': 'अपना मोटिवेशन ऊंचा रखें',
  'consistencyChart.subcopyMid': 'और',
  'consistencyChart.subcopyHighlight2': 'अपने मनचाहे शरीर तक पहुंचें',
  'consistencyChart.chartTitle': 'आपकी प्रगति',
  'consistencyChart.nowLabel': 'अभी',
  'consistencyChart.withLabel': 'FitClutch के साथ',
  'consistencyChart.withoutLabel': 'FitClutch के बिना',
  'consistencyChart.disclaimer': 'नोट: उदाहरण सिर्फ दिखाने के लिए हैं। वर्कआउट और खानपान में निरंतरता ही असली नतीजे लाती है।',
  'consistencyChart.cta': 'जारी रखें',

  'progressLoader.headline': 'आपकी पर्सनल वर्कआउट प्लान बनाई जा रही है',
  'progressLoader.item_bodyType': 'आपके शरीर के प्रकार और दिनचर्या के हिसाब से ढाला जा रहा है',
  'progressLoader.item_fitnessLevel': 'आपका फिटनेस लेवल आंका जा रहा है',
  'progressLoader.item_plan': 'आपकी पर्सनलाइज़्ड प्लान बनाई जा रही है',
  'progressLoader.testimonial1_title': 'मेरी दिनचर्या बदल दी',
  'progressLoader.testimonial1_body': 'आखिरकार एक ऐसी प्लान जो सच में मेरे हफ्ते में फिट बैठती है। फॉलो करना आसान है और वर्कआउट्स समझ आते हैं।',
  'progressLoader.testimonial1_author': 'रेनाटा ए.',
  'progressLoader.testimonial2_title': 'असली नतीजे',
  'progressLoader.testimonial2_body': 'बस कुछ हफ्तों में ही एनर्जी और ताकत में फर्क महसूस हुआ। प्लान मेरे हिसाब से ढलती है।',
  'progressLoader.testimonial2_author': 'जूलियाना एम.',
  'progressLoader.testimonial3_title': 'एक रूटीन जिसे मैं सच में फॉलो करती हूं',
  'progressLoader.testimonial3_body': 'FitClutch से पहले कभी कोई रूटीन नहीं टिकी। अब यह मेरे दिन का हिस्सा बन गई है।',
  'progressLoader.testimonial3_author': 'कार्ला एस.',
  'progressLoader.testimonial4_title': 'पूरी तरह वर्थ इट',
  'progressLoader.testimonial4_body': 'सिंपल, सीधा और पूरी तरह मेरे शरीर और मेरी दिनचर्या के हिसाब से बनाया गया।',
  'progressLoader.testimonial4_author': 'फर्नांडा ओ.',

  'emailCapture.headlineLead': 'अपनी ई-मेल डालें और पाएं अपनी',
  'emailCapture.headlineHighlight': 'पर्सनलाइज़्ड वर्कआउट प्लान',
  'emailCapture.placeholder': 'aapkaemail@example.com',
  'emailCapture.cta': 'जारी रखें',
  'emailCapture.privacyLead': 'हम आपकी प्राइवेसी का सम्मान करते हैं और आपका पर्सनल डेटा हमारी',
  'emailCapture.privacyLink': 'प्राइवेसी पॉलिसी',
};
